import React, { useState } from 'react'
import {Row,Col} from 'antd'
import { images } from '../Assets/ImagesExports/ImageExport'
import { useNavigate } from 'react-router-dom'
import { LogoutOutlined, UserOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'

const Instructor_Navbar = () => {
    const navigate = useNavigate()
    const[showLogout,setShowLogout] = useState(false)
  return (
    <div>

        <Row className='instructor_navbar'>
            <Col span={12} className='left'>
               <img src={images.logo} alt='logo' className='navbar_logo'/>
               <button className='visit_website_btn'
                 onClick={() => navigate('/')}
               >Visit Website</button>
            </Col>
            <Col span={12} className='right'>
                <div>
                  icon
                </div>
                <div className='profile_div'>
                   <img src={images.broken_instructor_jpg} alt='profile-image' className='navbar_user_icon'
                     onClick={() => setShowLogout(val => !val)}
                   />
                     
                   <div>
                      <h5>ravi</h5>
                      <p>Instructor</p>
                   </div>

                </div>
                {
                  showLogout &&
                  <div className='instructor_profile_info_div'>
                    <p>Welcome!</p>
                    <Link to={'/home/profile'} className="link"><p><UserOutlined /> My Account</p></Link>
                    <Link to={'/login'} className='link'><p><LogoutOutlined /> Logout</p></Link>
                </div>
                }
            </Col>
        </Row>
        
    </div>
  )
}

export default Instructor_Navbar
